import { Title, TitleProps } from "@mantine/core";
import clsx from "clsx";
import classes from "./styles.module.scss";

function SkillsterTitle(props: TitleProps & { withDivider?: boolean }) {
  const { withDivider, ...rest } = props;
  return (
    <Title
      {...rest}
      className={clsx({
        [classes.title]: true,
        [classes.divider]: withDivider,
      })}
    />
  );
}

export default SkillsterTitle;
